import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';


const ListItem = ({ styles, link, children, styleName, extraClassName }) => {
  const contentClassName = styles.columnItem ? `${styles.item} ${styles.columnItem}` : styles.item;
  const contentLinkClassName = styleName ? `${ styles.link } ${ styleName}` : styles.link;

  return (
    <li className={classNames(contentClassName, extraClassName)}>
      <Link
        to={link}
        className={contentLinkClassName}>
        {children}
      </Link>
    </li>
  );
};

ListItem.propTypes = {
  styles: PropTypes.object,
  link: PropTypes.oneOfType([
    PropTypes.object, PropTypes.string,
  ]).isRequired,
  children: PropTypes.node.isRequired,
  styleName: PropTypes.string,
  extraClassName: PropTypes.string,
};

ListItem.defaultProps = {
  styles: {},
  styleName: '',
  extraClassName: '',
};

export default ListItem;
